import {
    TOnActionType,
    TAnalyticsEventAction
} from '~/services/analytics/analytics.types';
import { User } from '~/models/user.model';

const onActionToAnalyticsAction: Record<TOnActionType, TAnalyticsEventAction> =
    {
        onClick: 'action',
        onBlur: 'blur'
    };

export function getAnalyticsAction(onActionType: TOnActionType) {
    return onActionToAnalyticsAction[onActionType];
}

export function buildSegmentIdentifyParams(
    _user: User,
    integrations?: Record<string, boolean>
) {
    const currCompany = _user.company;
    const currAccount = _user.account;

    const reservedTraits = {
        id: _user._id,
        avatar: _user.profile_image_url,
        company: {
            id: currCompany?._id,
            name: currCompany?.company_name
        },
        createdAt: _user.created_at,
        email: _user.email,
        firstName: _user.first_name,
        lastName: _user.last_name,
        name: _user.full_name,
        phone: currCompany?.phone_number,
        website: _user.website_url
    };
    const customTraits = {
        vertical: currCompany?.company_type,
        userType: _user.system_user_type,
        hbUserType: _user.hb_user_type,
        predictedMemberSegmentMeasurement:
            currAccount?.predicted_member_segment_measurement,
        trialStartDate: currAccount?.trial?.start_date,
        isSubscribed: currAccount?.is_subscribed,
        activatedOnDate: _user.activated_on,
        smartFileOpenDate: currAccount?.enable_flow_flag,
        legacyFilesBlockDate: currAccount?.block_files_flag,
        smartFilesRolloutGroup: currAccount?.otam_group,
        isAtwsPreTrialVendor: _user.isAtwsPreTrialVendor
    };
    const userTraits = {
        ...customTraits,
        ...reservedTraits
    };

    const options: {
        integrations: Record<string, boolean>;
    } = {
        integrations: integrations || {
            All: true,
            Iterable: false
        }
    };
    return { userTraits, options };
}
